import { Action } from 'redux';

import { areValid, areValidForTypes, getDefaultOrderForContentTypes, getDefaultOrderForSpaceInfo } from '~src/spacesPlatform/models/sort/SortOptionDefinitions';

import { isFilterContentTypeAction } from '../actions/ContentExplorerFilterActions';
import { isEnterSpaceAction } from '../actions/EnterSpaceAction';
import { isResetIgnoreNextOrderUrlChange, isSetIgnoreNextOrderUrlChange, isSetOrderAction } from '../actions/SetOrderAction';
import { OrderState } from '../state/OrderState';
import { isProjectSpace, SpaceInfo } from '../state/SpaceInfo';

export const InitialState: OrderState = {
  order: [],
  ignoreNextUrlChange: false
};

export function orderReducer(
  previousState: OrderState = InitialState,
  action: Action = null
): OrderState {
  if (isSetOrderAction(action)) {
    if (!action.order || action.order.length === 0) {
      // we don't want empty or null order arrays (e.g., if the url is just 'order=' or has an invalid order) so don't change the order
      // empty order means initial state (assumption in watchOrderParam in ExplorerUrlBindings)
      return previousState;
    }
    return {...previousState, order: action.order} || InitialState;

  // If the content filters or space info changes
  // we need to update sort to default sorts
  // These invalid cases shouldn't ever actually happen
  // with the logic in updateOrderQueryParamsIfMismatched
  } else if (isFilterContentTypeAction(action)) {
    if (!areValidForTypes(previousState.order, action.contentTypes)) {
      return {...previousState, order: getDefaultOrderForContentTypes(action.contentTypes)};
    }
  } else if (isEnterSpaceAction(action)) {
    const spaceInfo: SpaceInfo = {
      item: action.item,
      spaceType: action.spaceType,
      subspaceName: action.subspaceName
    };

    // Project space doesn't have content info on enter space, and relies on the
    // above isFilterContentTypeAction block to set up the filtering properly.
    // Otherwise, this can result in the project space ignoring query params that
    // are content type specific due to reseting to defaults here.
    // The favorites space (other mixed content view that uses filter content types) can
    // use default order for space info because its the same order regardless of content type(s)
    if (!isProjectSpace(spaceInfo) && (!areValid(previousState.order, [], spaceInfo) || previousState.order.length === 0)) {
      return {...previousState, order: getDefaultOrderForSpaceInfo(spaceInfo)};
    }

  } else  if (isResetIgnoreNextOrderUrlChange(action)) {
    return {...previousState, ignoreNextUrlChange: false};
  } else  if (isSetIgnoreNextOrderUrlChange(action)) {
    return {...previousState, ignoreNextUrlChange: true};
  }

  return previousState;
}
